import NextLink from "next/link";
import { Link as MUILink, Typography } from "@mui/material";
import Maybe from "./Maybe";

interface Props {
  href: string;
  children: JSX.Element;
  text?: string | React.ReactNode;
  sx?: object;
  underline?: "none" | "hover" | "always";
  target?: string;
}

const ContactLink = ({
  href,
  text,
  sx = {},
  underline = "none",
  target,
  children,
}: Props): JSX.Element => {
  return (
    <NextLink href={href} passHref>
      <MUILink
        underline={underline}
        component="a"
        target={target}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          borderRadius: "100vw",
          backgroundColor: "#fff",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
          color: "#212121",
          fontSize: "16px",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.12)",
            transform: "translateY(-1px)",
          },
          ...sx,
        }}
      >
        {children}
        <Maybe test={text}>
          <Typography component="span" variant="body2" fontWeight={400}>
            {text}
          </Typography>
        </Maybe>
      </MUILink>
    </NextLink>
  );
};

export default ContactLink;
